/* Velunna — facets.js: filtros y orden sin recargar (Storefront Filtering + Section Rendering API) */
(() => {
  const section = document.querySelector('[data-facets-section]');
  if (!section) return;
  const sectionId = section.dataset.sectionId;
  let ctrl; let timer;

  async function render(url, push = true) {
    const grid = section.querySelector('[data-facets-grid]');
    grid.classList.add('is-loading');
    const drawerOpen = !!section.querySelector('#FacetsDrawer.is-open');
    if (ctrl) ctrl.abort(); ctrl = new AbortController();
    try {
      const u = new URL(url, window.location.origin); u.searchParams.set('section_id', sectionId);
      const text = await fetch(u, { signal: ctrl.signal }).then((r) => r.text());
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const newGrid = doc.querySelector('[data-facets-grid]');
      const newWrap = doc.querySelector('[data-facets-wrapper]');
      if (newGrid) grid.innerHTML = newGrid.innerHTML;
      const wrap = section.querySelector('[data-facets-wrapper]');
      if (newWrap && wrap) {
        wrap.innerHTML = newWrap.innerHTML;
        if (drawerOpen) { const d = wrap.querySelector('#FacetsDrawer'); d.hidden = false; d.classList.add('is-open'); }
      }
      if (push) { const clean = new URL(url, window.location.origin); clean.searchParams.delete('section_id'); history.pushState({ facets: true }, '', clean); }
      if (window.VelunnaStore) window.VelunnaStore.initDynamic(grid);
      bind();
    } catch (e) { if (e.name !== 'AbortError') window.location.href = url; }
    finally { grid.classList.remove('is-loading'); }
  }

  function urlFromForm(form) {
    const params = new URLSearchParams(new FormData(form));
    for (const [k, v] of Array.from(params.entries())) if (v === '') params.delete(k);
    return `${form.action.split('?')[0]}?${params.toString()}`;
  }

  function bind() {
    const form = section.querySelector('[data-facets-form]');
    if (!form || form.dataset.bound) return; form.dataset.bound = '1';
    form.addEventListener('input', (e) => {
      if (!e.target.matches('[data-facet-input]')) return;
      clearTimeout(timer);
      timer = setTimeout(() => render(urlFromForm(form)), e.target.type === 'number' ? 600 : 0);
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); render(urlFromForm(form)); });
  }

  section.addEventListener('click', (e) => {
    const a = e.target.closest('[data-facet-remove], .pagination a');
    if (!a) return;
    e.preventDefault();
    render(a.href);
    if (a.closest('.pagination')) section.scrollIntoView({ behavior: 'smooth', block: 'start' });
  });
  window.addEventListener('popstate', () => render(window.location.href, false));
  bind();
})();
